import React from 'react';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { WhiteBadgeStyled } from '@/app/components/search/components/EvolutionCard/Badges/BaseBadge/styled.ts';

const SpaBadge = () => {
  const { t } = useTranslation();
  return <WhiteBadgeStyled dangerouslySetInnerHTML={{ __html: t('vacation.oss.cards.spa_included') }} />;
};

export default SpaBadge;
